import React from 'react';

import styles from "./Label.module.sass"
export default function Label({children, required = false, ...props}) {
  return (
    <label className={styles.label} {...props}>{children}{!!required && "*"}</label>
  )
}
